const loc_fr_strings = {
    "Login": {
        "HEADING": "Connexion FOLBB-ID Plateforme",
        "LOGIN": "Connexion",
        "USER": "Utilisateur",
        "PASSWORD": "Mot de passe",
        "LOGIN_FAIL": "Échec connexion",
        "LOGIN_FIELD_REQUIRED": "Le champ \" Nom d'utilisateur \" est obligatoire",
        "PASSWORD_FIELD_REQUIRED": "Le champ \"Mot de passe\" est obligatoire",
        "FORGOT_PASSWORD": "Mot de passe oublié ?",
        "DIFFERENT_ACCOUNT": "Se connecter avec un autre compte",
        "NO_ACCOUNT": "Pas de compte ?",
        "REGISTER": "S'enregistrer avec FOLBB digital",
        "CHANGE_DENIED_TEXT": "Veuillez utiliser p.ex. OWA pour changer votre mote de passe AD, ou contacter le service d'assistance."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Tableau de bord",
        "ACTION_TEXT": "Actions",
        "CHANGE_PASSWORD_TEXT": "Changer mot de passe",
        "MY_APPLICATIONS_TEXT": "Mes applications FOLBB",
        "APPLICATIONS_TEXT": "Applications FOLBB",
        "USERS_LIST_TEXT": "Gestion des utilisateurs"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Tableau de bord",
        "MY_APPLICATIONS_TEXT": "Mes applications FOLBB",
        "APPLICATIONS_TEXT": "Applications FOLBB"
    },
    "Header": {
        "USER_MENU_TEXT": "Menu utilisateur",
        "ACTION_TEXT": "Actions",
        "CHANGE_PASSWORD_TEXT": "Changer mot de passe",
        "USERS_LIST_TEXT": "Gestion des utilisateurs",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Ancien mot de passe",
        "NEW_PASSWORD": "Nouveau mot de passe",
        "CONFIRM_PASSWORD": "Confirmer mot de passe",
        "PASS_DO_NOT_MATCH": "␣Le mot de passe ne correspond pas",
        "PASSWORD_FIELD_REQUIRED": "Le champ \"Mot de passe\" est obligatoire",
        "OLD_PASSWORD_FIELD_REQUIRED": "L' \"Ancien mot de passe\" est un champ obligatoire",
        "SUCCESS_TEXT": "Le mot de passe a été modifié avec succès. ",
        "HEADING": "FOLBB-ID Modification identification",
        "HELP": "Besoin d'aide ?",
        "SAVE": "Modifier",
        "CANCEL": "Annuler",
        "PASSWORD_CHANGE_ERROR": "Les données n'ont pas pu être sauvegardées. Veuillez réessayer plus tard.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Le mot de passe doit contenir au moins 10 symboles, au moins un caractère en lettre minuscule, un autre en lettre majuscule, un caractère spécial et un chiffre",
        "PASSWORD_REQUIREMENTS_TEXT": "Le mot de passe doit satisfaire les exigences suivantes :",
        "LOWERCASE_LETTER_TEXT": "Au moins une lettre␣",
        "UPPERCASE_LETTER_TEXT": "Au moins une lettre majuscule",
        "NUMBER_TEXT": "Au moins un chiffre",
        "SPECIAL_SYMBOL_TEXT": "Au moins un symbole spécial",
        "PASSWORD_LENGTH_TEXT": "Contenir au moins 10 caractères",
        "PASSWORD_RESTRICTION_TEXT": "Le nom, prénom ou nom d'utilisateur ne doivent pas être contenus dans le mot de passe",
        "CHANGE_PASSWORD_TEXT": "Changer mot de passe",
        "ACTION_TEXT": "Actions",
        "CHANGE_DENIED_TEXT": "Veuillez utiliser p.ex. OWA pour changer votre mote de passe AD, ou contacter l'assistance."
    },
    "CreatePassword": {
        "PASSWORD": "Créer un mot de passe",
        "CONFIRM_PASSWORD": "Confirmer votre mot de passe",
        "PASS_DO_NOT_MATCH": "Le mot de passe ne correspond pas",
        "PASSWORD_FIELD_REQUIRED": "Le champ \"Mot de passe\" est obligatoire",
        "SUCCESS_TEXT": "Les données ont été sauvegardées avec succès",
        "HEADING": "Créer mot de passe",
        "HELP": "Besoin d'aide ?",
        "SAVE": "Modifier",
        "CANCEL": "Annuler",
        "PASSWORD_CHANGE_ERROR": "Les données n'ont pas pu être sauvegardées. Veuillez réessayer plus tard.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Le mot de passe doit contenir au moins 10 symboles, au moins un caractère en lettre minuscule, un autre en lettre majuscule, un caractère spécial et un chiffre",
        "PASSWORD_REQUIREMENTS_TEXT": "Le mot de passe doit satisfaire les exigences suivantes :",
        "LOWERCASE_LETTER_TEXT": "Au moins une lettre",
        "UPPERCASE_LETTER_TEXT": "Au moins une lettre majuscule",
        "NUMBER_TEXT": "Au moins un chiffre",
        "SPECIAL_SYMBOL_TEXT": "Au moins un symbole spécial",
        "PASSWORD_LENGTH_TEXT": "Contenir au moins 10 caractères",
        "PASSWORD_RESTRICTION_TEXT": "Le nom, prénom ou nom d'utilisateur ne doivent pas être contenus dans le mot de passe",
        "PASSWORD_WAS_SET": "Le lien a déjà été utilisé pour créer le mot de passe, si vous ne vous souvenez pas du mot de passe, veuillez utiliser la fonction de réinitialisation du mot de passe",
        "OLD_PASSWORD_REQUIRED": "L' \"Ancien mot de passe\" est un champ obligatoire",
        "MMID_CHANGE_PASSWORD": "Changer mot de passe",
        "OLD_PASSWORD": "Ancien mot de passe",
        "INVALID_OLD_PASSWORD": "Ancien mot de passe incorrect",
        "USER_NOT_FOUND_OR_INACTIVE": "Utilisateur introuvable ou inactif",
        "UNKNOWN_ERROR": "Une erreur s'est produite lors de la modification du mot de passe"
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Veuillez saisir une adresse e-mail correcte",
        "LOGIN_FIELD_REQUIRED": "Le champ \"E-mail\" est obligatoire",
        "HEADING": "Mot de passe oublié",
        "HELP": "Besoin d'aide ?",
        "SAVE": "Envoyer e-mail de réinitialisation du mot de passe",
        "CANCEL": "Annuler",
        "SUCCESS_TEXT": "Veuillez contrôler votre boîte de réception d'e-mail",
        "CHANGE_DENIED_TEXT": "Veuillez utiliser p.ex. OWA pour changer votre mote de passe AD, ou contacter l'assistance.",
        "PASSWORD_RESET_TOO_OFTEN": "La fonction de réinitialisation du mot de passe a été utilisée à de trop nombreuses reprises, veuillez réessayer plus tard.",
        "RESET_FAILED": "Échec connexion",
        "LINK_EXPIRED": "Votre connexion a expiré. Veuillez saisir votre adresse e-mail afin d'obtenir une nouvelle fois le lien de connexion.",
        "HEADING_EXPIRED": "Votre lien de connexion a expiré",
        "SAVE_EXPIRED": "Demander un lien de connexion"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gestion des utilisateurs",
        "ACTIVE": "Actif",
        "INACTIVE": "Inactif",
        "MMID": "FOLBBID",
        "OU": "Unité organisationnelle",
        "ORGANIZATION_UNIT": "Unité d'organisation",
        "LANGUAGE": "Langue",
        "OPEN_FILTER": "Ouvrir filtre",
        "CLOSE_FILTER": "Fermer filtre",
        "RESET": "réinitialiser",
        "RESET_ALL_FILTERS": "Réinitialiser les filtres",
        "SEARCH": "Recherche",
        "STATUS": "Statut",
        "GROUPS": "Groupes",
        "SHOW_ALL_DETAILS": "Montrer tous les détails",
        "SHOW_LESS": "Montrer moins",
        "ASCENDING": "Croissant",
        "DESCENDING": "Décroissant",
        "LIST_END": "Fin de liste",
        "SORT_BY_LASTNAME": "Trier par nom de famille",
        "SORT_BY_FIRSTNAME": "Tier par prénom",
        "SORT_BY_EMAIL": "Trier par e-mail",
        "SORT_BY_LANGUAGE": "Trier par langue de préférence",
        "SORT_BY_STATUS": "Trier par statut",
        "SORT_BY_OU": "Trier par OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Modifier",
        "CREATE": "Nouvel utilisateur",
        "DIGICREATE": "Nouvel utilisateur FOLBB digital",
        "ACTIVATE": "Activé",
        "DEACTIVATE": "Désactivé",
        "USER_WAS_ACTIVATED": "L'utilisateur a été activé",
        "USER_WAS_DEACTIVATED": "L'utilisateur a été désactivé",
        "ERROR_USER_ACTIVATION": "Une erreur s'est produite durant l'activation de l'utilisateur",
        "ERROR_USER_DEACTIVATION": "Une erreur s'est produite durant la désactivation de l'utilisateur",
        "SEND_FORGOT_PW_EMAIL": "Envoyer un e-mail pour mot de passe oublié",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail générique pour PW oublié",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail FOLBB digital PW oublié",
        "COMPANY": "Compagnie",
        "SEND_WELCOME_EMAIL": "Envoyer un e-mail de bienvenue",
        "SEND_WELCOME_EMAIL_DIGI": "Email de bienvenue FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail de bienvenue FOLBB digital sans bouton PW",
        "APPLY_FILTER_FOR_USERS": "Veuillez utiliser les filtres, ou chercher à afficher les résultats",
        "GENERATING_EMAIL": "Génération d'e-mail ....",
        "ERROR_EMAIL_GENERATE": "Erreur lors de la génération de l'e-mail ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gestion des utilisateurs",
        "USER_WAS_ACTIVATED": "L'utilisateur a été activé",
        "USER_WAS_DEACTIVATED": "L'utilisateur a été désactivé",
        "ERROR_USER_ACTIVATION": "Une erreur s'est produite durant l'activation de l'utilisateur",
        "ERROR_USER_DEACTIVATION": "Une erreur s'est produite durant la désactivation de l'utilisateur",
        "LOADING_USER_ERROR": "Une erreur s'est produite lors de la connexion de l'utilisateur",
        "FIRSTNAME": "Prénom",
        "LASTNAME": "Nom",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Nom de connexion de l'utilisateur (pre-windows 2000)",
        "LANGUAGE": "Langue",
        "PRINCIPAL_NAME": "Nom de l'utilisateur principal",
        "OU": "Unité d'organisation",
        "CLASS_DISPLAY_NAME": "Afficher le nom",
        "PHONE": "Téléphone",
        "WEBSITE": "Site web",
        "COUNTRY": "Pays",
        "STATE": "État",
        "LOCATION": "Ville",
        "STREET": "Rue",
        "POSTAL_CODE": "Code postal",
        "COMPANY": "Compagnie",
        "DEPARTMENT": "Service",
        "PERSONAL_TITLE": "Intitulé du poste",
        "MANAGER": "Manager",
        "DESCRIPTION": "Description",
        "GROUPS": "Groupes",
        "SAVE": "Sauvegarder",
        "CANCEL": "Annuler",
        "USER_STATUS": "Statut de l'utilisateur",
        "ACTIVE": "Actif",
        "INACTIVE": "Inactif",
        "ACTIVATE": "Activé",
        "DEACTIVATE": "Désactivé",
        "USER_WAS_SAVED": "L'utilisateur a été sauvegardé",
        "UNKNOWN_ERROR": "Une erreur inconnue s'est produite lors de la sauvegarde de l'utilisateur",
        "PROXY_ADDRESSES": "Adresses Proxy",
        "BROWSE": "Naviguer",
        "REMOVE": "Enlever",
        "ONLY_JPG": "Seules les images jpg sont acceptées !",
        "FILE_SIZE": "La taille du fichier doit être inférieure à 100 KB !",
        "DIMENSIONS": "La dimension maximale des images est 96x96 pixels !",
        "SEND_FORGOT_PW_EMAIL": "Envoyer un e-mail pour mot de passe oublié",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail générique pour PW oublié",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail FOLBB digital PW oublié",
        "VIRUS_FOUND": "L'utilisateur n'a pas pu être enregistré. Des logiciels malveillants ont été trouvés dans la pièce jointe. Le fichier ne sera pas téléchargé. Veuillez contacter votre administrateur système.",
        "VIRUS_SCANNER_NOT_AVL": "Le fichier n'a pas pu être analysé contre les logiciels malveillants. Veuillez réessayer plus tard. Si le problème persiste, contactez votre administrateur système.",
        "INFO": "Info :",
        "SEND_WELCOME_EMAIL": "Envoyer un e-mail de bienvenue",
        "SEND_WELCOME_EMAIL_DIGI": "Email de bienvenue FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail de bienvenue FOLBB digital sans bouton PW",
        "SAVING_USER_SPINNER": "Sauvegarder l'utilisateur...Patientez",
        "DUPLICATE_USER": "L'utilisateur existe déjà",
        "GENERATING_EMAIL": "Génération d'e-mail ....",
        "ERROR_EMAIL_GENERATE": "Erreur lors de la génération de l'e-mail ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Utilisateur introuvable",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Générer un e-mail de bienvenue ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "L'utilisateur a été activé",
        "USER_WAS_DEACTIVATED": "L'utilisateur a été désactivé",
        "ERROR_USER_ACTIVATION": "Une erreur s'est produite durant l'activation de l'utilisateur",
        "ERROR_USER_DEACTIVATION": "Une erreur s'est produite durant la désactivation de l'utilisateur",
        "EMAIL_WAS_SENT": "L'e-mail a été envoyé correctement",
        "EMAIL_NOT_SENT_USER_ACTIVE": "L'e-mail n'a pas été envoyé. L'utilisateur est déjà actif. Utilisez à la place la fonctionnalité Envoyer un mot de passe oublié",
        "ERROR_EMAIL_SEND": "Erreur lors de l'envoi de l'email",
        "EMAIL_NOT_SENT_USER_INACTIVE": "L'e-mail n'a pas été envoyé. L'utilisateur est inactif. Utilisez la fonctionnalité Envoyer un e-mail d'inscription FOLBB digital.",
        "PASSWORD_RESET_TOO_OFTEN": "La fonction de réinitialisation du mot de passe a été utilisée à de trop nombreuses reprises, veuillez réessayer plus tard.",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

export default loc_fr_strings;



// WEBPACK FOOTER //
// ./src/resources/fr.js